export default __webpack_public_path__ + "static/media/Flexa ausmessen seitlich.152b2c4e.jpg";